import { render } from "./StudentSkillAssessmentDialog.vue?vue&type=template&id=d46e398e&scoped=true"
import script from "./StudentSkillAssessmentDialog.vue?vue&type=script&lang=js"
export * from "./StudentSkillAssessmentDialog.vue?vue&type=script&lang=js"

import "./StudentSkillAssessmentDialog.vue?vue&type=style&index=0&id=d46e398e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46e398e"]])

export default __exports__